// import { StudentService} from '../../services/student.service';
// import { LoginUserService } from '../services/loginuser.service';
// import { AlertService } from '../../services/alert.service';
// import { Observable, Subject, from } from 'rxjs';
// import { RestService } from '../../rest.service';
// import { first } from 'rxjs/operators';
// import { Mhsrcuser } from '../../models/user';
// import { stringify } from '@angular/compiler/src/util';
// import { DataSharingService } from '../../services/data-sharing.service';
// import { CommonDataService } from '../../services/common-data.service';
// import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
// import { formArrayNameProvider } from '@angular/forms/src/directives/reactive_directives/form_group_name';
import { CreateLogin } from '../../models/create-login';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-create-login',
  templateUrl: './create-login.component.html',
  styleUrls: ['./create-login.component.css']
})
export class CreateLoginComponent implements OnInit {
  createLogin: CreateLogin = new CreateLogin();
  disableSend = true;
  msg = '';
     loading = false;
     submitted = false;

    constructor(
      private _router: Router,
      private _userService: UserService) {
        // Init container for request
        this.createLogin = new CreateLogin();
      }

  ngOnInit() {
  }

  sendCreateLogin(createLogin: NgForm): void {
    if (!(this.createLogin.password === this.createLogin.confirmpass)) {
      this.msg = 'Passwords must match';
      return;
    }
    this._userService.GetUserByEmail(this.createLogin.email)
    .subscribe(
      res => this.getUserSuccess(res),
      error1 => this.getUserFailed(error1),
      );
  }

  getUserSuccess(res: any): void {
    if (res.email != null) {
      alert('That email address is already in use. If it is yours and you have forgotten your password, please request a password reset.');
      this._router.navigate(['mhs-login']);
    } else {
      this.getUserFailed('This should never happen');
    }
  }

  getUserFailed(error1: any): void {
    this.submitted = true;
      // form is valid and dirty - send request'
      this.loading = true;
      this.createLogin.roleId = '1';
      this._userService.sendCreateLogin(this.createLogin)
        .subscribe(
          result => this.sendCreateLoginSuccessful(result),
          error => this.sendCreateLoginFailed(error),
          () => {
            console.log('LoginCreated!');
          }
        )
      ;
    }

  sendCreateLoginSuccessful(result: any) {
    // this.loading = false;
    console.log(result.message);
    this.msg = result.message;
    setTimeout(() => {
      // show message for 2 seconds, then redirect back to main?
      this.msg = 'Returning to the Login page. Please log in with your new email and password.';
      // Navigate back to the login screen
      setTimeout(() => { this._router.navigate(['mhs-login']); }, 4000);
    }, 4000);
}

  sendCreateLoginFailed(error: any) {
    // this.loading = false;
    console.log(error.message);
    this.msg = error.message;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/create-login/create-login.component.ts